import Vue from 'vue';
import store from './../../store';
import campaignTransformer from './../../transformers/campaign';
import paginationTransformer from '../../transformers/pagination';

const success = ({ data }, resolve) => {
  const campaigns = campaignTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedCampaigns', { campaigns, pagination });
  resolve(data);
};

const failed = (error, reject) => reject(error);


export default (page = 1, limit = 10) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`news_campaigns?page=${page}&limit=${limit}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/campaign/items.js